import { GraphQLSupporter } from '@sola/schema/dotcom/supporters/schema.generated.js';

// NOTE Should these live in schema and be autogenerated when there are changes to the GraphQL schema?
export const MOCK_SUPPORTER_MIXED_COMMITMENTS: GraphQLSupporter = {
  address: {
    street: '1732 Gabriella Dr',
    city: 'Oxnard',
    state: 'CA',
    postalCode: '93030-7667',
    country: 'United States',
    invalid: false,
    __typename: 'SupporterAddress',
  },
  commitments: [
    {
      __typename: 'Commitment',
      participant: {
        birthdate: '2014-04-25',
        country: 'Colombia',
        gender: 'Female',
        globalId: '08314403',
        __typename: 'CommitmentParticipant',
        localId: 'CO075900062',
        name: 'Luciana',
        names: {
          preferred: 'Luciana',
        },
        photoUrl:
          'https://media.ci.org/w_150/v1536346920/ChildPhotos/Published/08314403_iskbag.jpg',
      },
      commitmentType: 'GiftCommitment',
      dates: {
        start: '2020-02-10',
        end: '2020-08-26',
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'BG',
        description: 'Birthday Gift',
        icon: 'birthday-cake',
        __typename: 'CommitmentFund',
      },
      id: 'CN-11818661',
      internalId: 'a1o3b000006Lp9nAAC',
      interventionId: null,
      isCorrespondent: null,
      isRecurring: false,
      lastCorrespondenceDate: null,
      paymentFrequency: 'Annually',
      paymentMethodId: null,
      paymentPullDay: null,
      rate: 20,
      receiptorId: '09090785',
      sourceCode: '593870',
      status: 'Closed',
      transactionId: 'T-063514761',
      _sys: {
        billingType: 'Billing',
        delinkType: null,
        linkType: null,
        program: 'Gifts',
        recordType: 'Gifts',
        subProgram: null,
        __typename: 'CommitmentSys',
      },
    },
    {
      __typename: 'Commitment',
      participant: {
        birthdate: '2014-04-25',
        country: 'Colombia',
        gender: 'Female',
        globalId: '08314403',
        __typename: 'CommitmentParticipant',
        localId: 'CO075900062',
        name: 'Luciana',
        names: {
          preferred: 'Luciana',
        },
        photoUrl:
          'https://media.ci.org/w_150/v1536346920/ChildPhotos/Published/08314403_iskbag.jpg',
      },
      commitmentType: 'ChildSponsorship',
      dates: {
        start: '2019-11-20',
        end: '2020-08-26',
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'DS',
        description: 'Child Sponsorship Support',
        __typename: 'CommitmentFund',
      },
      id: 'CN-11420555',
      internalId: 'a1o3b000006AHvqAAG',
      interventionId: null,
      isCorrespondent: true,
      isRecurring: false,
      lastCorrespondenceDate: '2020-02-06',
      paymentFrequency: 'Monthly',
      paymentMethodId: null,
      paymentPullDay: null,
      rate: 38,
      receiptorId: '09090785',
      sourceCode: '595241',
      status: 'Closed',
      transactionId: 'BENORD0018623129',
      _sys: {
        billingType: 'Billing',
        delinkType: 'Sponsor-Requested Cancellation',
        linkType: 'New Assignment',
        program: 'CDSP',
        recordType: 'Ongoing Commitments',
        subProgram: 'Sponsor',
        __typename: 'CommitmentSys',
      },
    },
    {
      __typename: 'Commitment',
      participant: null,
      commitmentType: 'GiftCommitment',
      dates: {
        start: '2025-09-08',
        end: null,
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'CF',
        description: 'Christmas Gift Program',
        icon: 'christmas-gift',
        __typename: 'CommitmentFund',
      },
      id: 'CN-21110207',
      internalId: 'a1oOt00000VCJzcIAH',
      interventionId: null,
      isCorrespondent: null,
      isRecurring: true,
      lastCorrespondenceDate: null,
      paymentFrequency: 'Annually',
      paymentMethodId: 'a2LOt000008s0BJMAY',
      paymentPullDay: '8',
      rate: 150,
      receiptorId: '09090785',
      sourceCode: '15138',
      status: 'Active',
      transactionId: null,
      _sys: {
        billingType: 'Billing',
        delinkType: null,
        linkType: null,
        program: 'Funds',
        recordType: 'Donations',
        subProgram: null,
        __typename: 'CommitmentSys',
      },
    },
    {
      __typename: 'Commitment',
      participant: null,
      commitmentType: 'FundCommitment',
      dates: {
        start: '2025-09-08',
        end: null,
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'ER',
        description: 'Disaster Relief',
        icon: 'cloud-raining-03',
        __typename: 'CommitmentFund',
      },
      id: 'CN-21110204',
      internalId: 'a1oOt00000VCJzZIAX',
      interventionId: null,
      isCorrespondent: null,
      isRecurring: true,
      lastCorrespondenceDate: null,
      paymentFrequency: 'Monthly',
      paymentMethodId: 'a2LOt000008s0BJMAY',
      paymentPullDay: '4',
      rate: 10,
      receiptorId: '09090785',
      sourceCode: '15138',
      status: 'Active',
      transactionId: null,
      _sys: {
        billingType: 'Billing',
        delinkType: null,
        linkType: 'New Assignment',
        program: 'Continuity Funds',
        recordType: 'Ongoing Commitments',
        subProgram: null,
        __typename: 'CommitmentSys',
      },
    },
    {
      __typename: 'Commitment',
      participant: null,
      commitmentType: 'FundCommitment',
      dates: {
        start: '2025-09-08',
        end: null,
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'MF',
        description: 'Survival Intervention',
        icon: 'mom-baby',
        __typename: 'CommitmentFund',
      },
      id: 'CN-21110205',
      internalId: 'a1oOt00000VCJzaIAH',
      interventionId: null,
      isCorrespondent: null,
      isRecurring: true,
      lastCorrespondenceDate: null,
      paymentFrequency: 'Monthly',
      paymentMethodId: 'a2LOt000008s0BJMAY',
      paymentPullDay: '4',
      rate: 12,
      receiptorId: '09090785',
      sourceCode: '15138',
      status: 'Active',
      transactionId: null,
      _sys: {
        billingType: 'Billing',
        delinkType: null,
        linkType: 'New Assignment',
        program: 'Continuity Funds',
        recordType: 'Ongoing Commitments',
        subProgram: null,
        __typename: 'CommitmentSys',
      },
    },
    {
      __typename: 'Commitment',
      participant: null,
      commitmentType: 'FundCommitment',
      dates: {
        start: '2025-09-08',
        end: null,
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'UC',
        description: 'Unsponsored Children',
        icon: 'children',
        __typename: 'CommitmentFund',
      },
      id: 'CN-21110206',
      internalId: 'a1oOt00000VCJzbIAH',
      interventionId: null,
      isCorrespondent: null,
      isRecurring: true,
      lastCorrespondenceDate: null,
      paymentFrequency: 'Monthly',
      paymentMethodId: 'a2LOt000008s0BJMAY',
      paymentPullDay: '4',
      rate: 9,
      receiptorId: '09090785',
      sourceCode: '15138',
      status: 'Active',
      transactionId: null,
      _sys: {
        billingType: 'Billing',
        delinkType: null,
        linkType: 'New Assignment',
        program: 'Continuity Funds',
        recordType: 'Ongoing Commitments',
        subProgram: null,
        __typename: 'CommitmentSys',
      },
    },
    {
      __typename: 'Commitment',
      participant: null,
      commitmentType: 'FundCommitment',
      dates: {
        start: '2025-09-08',
        end: null,
        __typename: 'CommitmentDates',
      },
      fund: {
        code: 'MN',
        description: 'Where Most Needed',
        icon: 'heart-hand',
        __typename: 'CommitmentFund',
      },
      id: 'CN-21110203',
      internalId: 'a1oOt00000VCJzYIAX',
      interventionId: null,
      isCorrespondent: null,
      isRecurring: true,
      lastCorrespondenceDate: null,
      paymentFrequency: 'Monthly',
      paymentMethodId: 'a2LOt000008s0BJMAY',
      paymentPullDay: '4',
      rate: 15,
      receiptorId: '09090785',
      sourceCode: '15138',
      status: 'Active',
      transactionId: null,
      _sys: {
        billingType: 'Billing',
        delinkType: null,
        linkType: 'New Assignment',
        program: 'Continuity Funds',
        recordType: 'Ongoing Commitments',
        subProgram: null,
        __typename: 'CommitmentSys',
      },
    },
  ],
  email: 'charlie.fergison@gmail.com.invalid',
  globalId: '09090785',
  givingTotals: {
    amountDue: '0',
    amountWaived: '0',
    annual: '150',
    creditRemaining: '0',
    monthly: '46',
    quarterly: '0',
    semiAnnual: '0',
    __typename: 'GivingTotals',
  },
  language: 'English',
  displayName: 'Charlie',
  names: {
    given: 'Charlie',
    surname: 'Fergison',
    preferred: 'Charlie',
    suffix: null,
    prefix: null,
    __typename: 'SupporterNames',
  },
  organization: null,
  isGroup: false,
  paymentMethods: [
    {
      id: 'a2LOt000008s0BJMAY',
      isPrimary: true,
      status: 'Active',
      accountNickname: null,
      sourceCode: null,
      isSavedForReuse: true,
      billingAddress: {
        attention: null,
        street: '1732 Gabriella Dr',
        city: 'Oxnard',
        stateCode: 'CA',
        postalCode: '93030-7667',
        country: 'United States',
      },
      paymentType: 'ACH',
      creditCard: null,
      ach: {
        accountName: 'Charlie Fergison',
        lastFourOfAccountNumber: '5312',
        routingNumber: '021200025',
        token: '3U37LV5UEYWOOA4G0',
      },
      isCreatedForReceiptor: true,
      __typename: 'SupporterPaymentMethod',
    },
    {
      id: 'a2LOt000008s0BJMAY',
      isPrimary: false,
      status: 'Active',
      accountNickname: null,
      sourceCode: null,
      isSavedForReuse: true,
      billingAddress: {
        attention: null,
        street: '1732 Gabriella Dr',
        city: 'Oxnard',
        stateCode: 'CA',
        postalCode: '93030-7667',
        country: 'United States',
      },
      paymentType: 'Credit Card',
      creditCard: {
        cardholderName: 'Charlie Fergison',
        cardType: 'Visa',
        digitalType: null,
        expirationDate: '12/2026',
        expiryStatus: null,
        lastFour: '5678',
        responseCode: '1234',
        token: '1234',
      },
      ach: null,
      isCreatedForReceiptor: true,
      __typename: 'SupporterPaymentMethod',
    },
    {
      id: 'a2LOt000008s0BJMAY',
      isPrimary: false,
      status: 'ExpiringSoon',
      accountNickname: null,
      sourceCode: null,
      isSavedForReuse: true,
      billingAddress: {
        attention: null,
        street: '1732 Gabriella Dr',
        city: 'Oxnard',
        stateCode: 'CA',
        postalCode: '93030-7667',
        country: 'United States',
      },
      paymentType: 'Credit Card',
      creditCard: {
        cardholderName: 'Charlie Fergison',
        cardType: 'Visa',
        digitalType: null,
        expirationDate: '12/2025',
        expiryStatus: 'EXPIRING_SOON',
        lastFour: '5678',
        responseCode: '1234',
        token: '1234',
      },
      ach: null,
      isCreatedForReceiptor: true,
      __typename: 'SupporterPaymentMethod',
    },
    {
      id: 'a2LOt000008s0BJMAY',
      isPrimary: false,
      status: 'Expired',
      accountNickname: null,
      sourceCode: null,
      isSavedForReuse: true,
      billingAddress: {
        attention: null,
        street: '1732 Gabriella Dr',
        city: 'Oxnard',
        stateCode: 'CA',
        postalCode: '93030-7667',
        country: 'United States',
      },
      paymentType: 'Credit Card',
      creditCard: {
        cardholderName: 'Charlie Fergison',
        cardType: 'Visa',
        digitalType: null,
        expirationDate: '8/2025',
        expiryStatus: 'EXPIRED',
        lastFour: '5678',
        responseCode: '1234',
        token: '1234',
      },
      ach: null,
      isCreatedForReceiptor: true,
      __typename: 'SupporterPaymentMethod',
    },
  ],
  primaryContactId: '0033b00002g6h35AAA',
  specialHandling: {
    correspondenceDeliveryPreference:
      'Email of Letter Image and Printed Digital Document',
    __typename: 'SupporterSpecialHandling',
  },
  status: 'Active',
  type: {
    level1: 'Household',
    level2: 'Individual',
    level3: null,
  },
  __typename: 'Supporter',
};
